<template>
  <div :style="styleObject">
    <f7-popup
      style="
        display: block;
        width: 320px;
        left: 50%;
        margin-left: -160px;
        maxheight: 600px;
        top: 50%;
        margin-top: -300px;
      "
      :opened="popupOpened"
      @popup:closed="close"
    >
      <f7-page>
        <f7-navbar
          v-if="!hideHeaderValue"
          :title="titleText"
          style="font-size: 16px; height: 40px !important"
        >
          <f7-nav-right>
            <f7-link @click="close">Close</f7-link>
          </f7-nav-right>
        </f7-navbar>

        <f7-block class="mt-2 px-1 text-center">
          <div v-if="step == 1">
            <div class="my-3 font-weight-bold">
              Which day are you available?
            </div>

            <div
              v-if="days"
              class="my-3 position-relative mx-auto"
              style="width: 80%"
            >
              <div class="swiper-container" id="chatBookDaySwiper">
                <div class="swiper-wrapper">
                  <div v-for="d in days" :key="d.full" class="swiper-slide">
                    <button
                      @click="selectDay(d.full)"
                      :class="bookDate == d.full ? 'btn-ls-y' : 'btn-light'"
                      class="btn"
                    >
                      {{ d.w }}
                      <br />
                      {{ d.d }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev day-prev"></div>
              <div class="swiper-button-next day-next"></div>
            </div>
            <div class="mt-5 mb-3 font-weight-bold">
              What time would suit you?
            </div>
            <div>
              <!-- <b-select v-model="bookTime" class="mt-2" style="width:120px">
                <option v-for="t in times" :key="t" :value="t">{{t}}</option>
              </b-select>-->
              <button
                v-for="t in times"
                :key="t"
                :class="bookTime == t ? 'btn-ls-y' : 'btn-light'"
                @click="selectTime(t)"
                class="btn px-2 mr-1 mb-1"
              >
                {{ t }}
              </button>

              <!-- <div class="swiper-container" id="chatBookTimeSwiper">
                <div class="swiper-wrapper">
                  <div v-for="t in times" :key="t" class="swiper-slide">
                    <button
                      @click="selectTime(t)"
                      :class="bookTime==t? 'btn-info':'btn-light'"
                      class="btn"
                    >{{t}}</button>
                  </div>
                </div>
                
              </div>-->
            </div>

            <div class="text-black-50 mt-3 font-weight-bold">Address:</div>
            <p v-if="curStore" class="mt-2 text-secondary">
              {{ curStore.address }}
            </p>

            <div v-if="curStore" class="text-center my-2">
              <a
                :href="curStore.map_url"
                @click="goToMapUrl(curStore.map_url)"
                target="_blank"
                class="btn btn-light text-capitalize px-4 mt-2 link"
              >
                <b-img height="30" :src="mapIconUrl" center />
              </a>
            </div>

            <div class="text-center mt-3">
              <p v-if="errorMesg" class="text-danger">{{ errorMesg }}</p>
              <button
                :class="bookDate ? '' : 'disabled'"
                @click="confirmBook"
                class="btn btn-ls-g rounded-pill px-5"
              >
                Send
              </button>
            </div>
          </div>

          <div v-if="step == 2" class="text-center">
            <div
              class="rounded-circle border border-ls-y border-size-2 mx-auto"
              style="width: 100px; height: 100px"
            >
              <b-img
                width="50"
                src="https://cdn-cf2.lovestruck.com/upload-s/gen/img/2020/calender_icon_large.png"
                center
                class="mt-3"
              />
            </div>

            <p class="text-black-50 font-weight-bold mt-5">
              Consultation Appointment
            </p>
            <p class="mt-2 mb-3">{{ bookDateFormat }}</p>

            <div class="text-black-50 mt-5 font-weight-bold">Address:</div>
            <p v-if="curStore" class="mt-2 mb-3 text-secondary">
              {{ curStore.address }}
            </p>

            <div v-if="curStore" class="text-center my-3">
              <a
                :href="curStore.map_url"
                @click="goToMapUrl(curStore.map_url)"
                target="_blank"
                class="btn btn-light text-capitalize px-4 mt-2 link"
              >
                <b-img height="30" :src="mapIconUrl" center />
              </a>
            </div>

            <div class="text-center mt-5">
              <a
                href="javascript:;"
                @click="close"
                class="btn btn-secondary text-capitalize px-4 mt-2"
                >Close</a
              >
            </div>
          </div>
        </f7-block>
      </f7-page>
    </f7-popup>
  </div>
</template>
<script>
if (typeof window != "undefined") {
  var VueAwesomeSwiper = require("vue-awesome-swiper/dist/ssr");
}
export default {
  name: "scheduleConsultation",
  data() {
    return {
      titleText: "Schedule Consultation",
      popupOpened: false,
      inputData: {},
      styleObject: {
        display: "none",
      },
      errorMesg: null,
      step: 1,
      show: false,
      days: null,
      selectMonth: "",
      bookDate: "",
      bookTime: "12:00",
      chatBookDaySwiper: null,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 3,
        freeMode: true,
      },
      times: [
        "12:00",
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
        "19:30",
        "20:00",
        // "20:30"
      ],
      client: null,
      booking: null,
      curStore: null,
      hideHeaderValue: true,
      bookDateFormat: "",
      cdnImgBaseUrl: "https://cdn-cf2.lovestruck.com/upload-s/gen/img/2020/",
      mapIconUrl: "",
    };
  },
  methods: {
    goToMapUrl(url) {
      //   window.top.location.href = url;
      window.open(url);
    },
    getClient() {
      let self = this;
      self.$layer.loading();

      let medata = JSON.parse(localStorage.getItem("userInfoData"));
      console.log("medata", medata);
      if (medata) {
        self.client = _.get(medata, "data.client");
        self.booking = _.get(medata, "data.booking");
        self.curStore = _.get(medata, "data.store");

        self.initData();
        self.initDaySwiper();
        self.$layer.closeAll("loading");
        return;
      }

      //   self.$api
      //     .getClientMe(self.$store.state)
      self.$http
        .get(`/api/v2/client/me`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        })
        .then((rs) => {
          console.log("meme=", rs, _.get(rs, "data.client"));
          self.$layer.closeAll("loading");

          self.client = _.get(rs, "data.client");
          self.booking = _.get(rs, "data.booking");
          self.curStore = _.get(rs, "data.store");

          localStorage.setItem("userInfoData", JSON.stringify(rs));
          self.initData();
        })
        .catch((err) => {
          self.$layer.closeAll("loading");

          // console.log(['me error', err]);
        });
    },
    initBooking() {
      let self = this;
      let consultation_time = _.get(self.booking, "consultation_time");
      // console.log("initBooking");
      if (consultation_time) {
        let d = self.$moment(consultation_time);
        self.bookDate = d.format("YYYY-MM-DD");
        self.bookTime = d.format("HH:mm");

        self.bookDateFormat = d.format("DD MMMM, HH:mm");
      }
    },
    confirmBook() {
      let self = this;

      if (!self.bookDate || !self.bookTime) {
        self.errorMesg = "invalid date";
        // self.$layer.msg(self.$t("invalid_date"));
        return false;
      }

      let dateString = `${self.bookDate} ${self.bookTime}`;
      let md = self.$moment(dateString);
      if (!md.isValid()) {
        self.errorMesg = "invalid date";
        // self.$layer.msg(self.$t("invalid_date"));
        return false;
      }
      //consultation_time
      let fdata = new FormData();
      fdata.append("consultation_time", md.format("YYYY-MM-DD HH:mm:ss"));
      self.$layer.loading();
      //   self.$api
      //     .postBookConsultation(fdata, self.$store.state)

      self.$http
        .post(`/api/v2/client/bookConsultation`, fdata)
        .then((rs) => {
          // console.log("postBookConsultation", rs);
          self.$layer.closeAll("loading");
          // self.bookResContent = _.get(rs, "book_consultation_res").replace(
          //   /\n/g,
          //   "<br/><br/>"
          // );
          self.bookDateFormat = md.format("DD MMMM, HH:mm");
          self.hideHeaderValue = true;
          self.titleText = null;
          self.mapIconUrl = _.get(
            self.curStore,
            "map_icon_url",
            `${self.cdnImgBaseUrl}google_maps_icon.png`
          );
          self.step = 2;
          localStorage.removeItem("userInfoData");
          // self.showClose = true;
        })
        .catch((err) => {
          self.$layer.closeAll("loading");
          console.log("err", err);
        });
    },
    selectTime(time) {
      let self = this;
      self.bookTime = time;
    },
    selectDay(date) {
      let self = this;
      self.bookDate = date;
      let i = _.findIndex(self.days, { full: date });
      self.selectMonth = _.get(self.days, `${i}.m`);
    },
    createDays() {
      let self = this;
      // console.log("createDays", self.lang);
      self.$moment.locale(self.lang);
      // self.$moment.locale("th");
      // self.$moment.locale("zh_CN");
      // self.$moment.locale("zh_HK");
      let now = self.$moment();
      let days = [
        // {
        //   m: now.format("MMMM"),
        //   w: now.format("ddd"),
        //   d: now.format("DD"),
        //   full: now.format("YYYY-MM-DD")
        // }
      ];
      // console.log(now.format("YYYY-MM-DD"));

      for (let d = 1; d <= 10; d++) {
        let newd = now.add(1, "d");
        days.push({
          m: newd.format("MMMM"),
          w: newd.format("ddd"),
          d: newd.format("DD"),
          full: newd.format("YYYY-MM-DD"),
        });
      }

      // console.log("days", days);
      self.days = days;
      self.selectMonth = _.get(self.days, `0.m`);
      self.bookDate = _.get(self.days, `0.full`);
      //   self.initDaySwiper();
    },
    initData() {
      let self = this;

      // console.log(self.$moment.locales());

      if (self.step == 1) {
        self.hideHeaderValue = false;
        self.titleText = "Schedule Consultation";
        self.initBooking();
        self.createDays();
      } else if (self.step == 2) {
        self.hideHeaderValue = true;
        self.titleText = null;

        self.initBooking();
        //baidu_map_icon,google_maps_icon
      }

      self.mapIconUrl = _.get(
        self.curStore,
        "map_icon_url",
        `${self.cdnImgBaseUrl}google_maps_icon.png`
      );
    },
    open(step) {
      let self = this;
      self.popupOpened = true;
      self.styleObject.display = "block";
      //   self.inputData = data;
      self.step = step;
      console.log("step:" + step);
      self.getClient();
      //   self.createDays();
    },
    close() {
      let self = this;
      self.popupOpened = false;
      self.styleObject.display = "none";
      self.step = 1;
    },
    initDaySwiper() {
      let self = this;
      if (VueAwesomeSwiper) {
        // self.daySwiper = null;
        // console.log("self.daySwiper=", self.daySwiper);
        // if (self.daySwiper) {
        //   if (self.daySwiper[0]) {
        //     self.daySwiper[0].observer.destroy();
        //   } else {
        //     self.daySwiper.destroy();
        //   }
        // }

        setTimeout(function () {
          //   self.swiperOption.pagination = {
          //     el: ".day-pagination",
          //     type: "progressbar",
          //   }
          self.swiperOption.navigation = {
            nextEl: ".day-next",
            prevEl: ".day-prev",
          };

          self.chatBookDaySwiper = new VueAwesomeSwiper.Swiper(
            "#chatBookDaySwiper",
            self.swiperOption
          );
          //   self.chatBookDaySwiper = new VueAwesomeSwiper.Swiper(
          //     "#chatBookTimeSwiper",
          //     self.swiperOption
          //   );

          //   console.log("self.daySwiper=", self.daySwiper);
        }, 10);
      }
    },
  },
};
</script>
<style scoped>
.swiper-button-next,
.swiper-button-prev {
  background-image: none;
  color: #d5b26f;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 20px;
}
.swiper-button-prev {
  left: -35px;
  top: 42px;
}
.swiper-button-next {
  right: -35px;
  top: 42px;
}
</style>